import React from "react";
import { ElementContext } from "./useElementContext";
import { getTypeName } from "./types";

export function ElementTag(props: {
	side?: "left",
}) {
	const elementContext = React.useContext(ElementContext);

	return (
		<div className={"element-tag " + (props.side ? props.side : "")}>
			<div className={"tag " + (props.side ? "secondary" : "")}>{getTypeName(elementContext.def.type)}</div>
		</div>
	);
}